export default "__VITE_ASSET__CPDVgs0f__"